import { accountModuleQuery, useModule } from 'system/structure-modules';

export default function AccountScreen() {
    const { AccountScreen } = useModule(accountModuleQuery);
    return <AccountScreen />;
}
